<template>
  <div class="contenedor" >
    <div class="Row1">
      <div class="Blk-SVE">
        <img class="logo" src="../assets/LogoOriginalSVE.png" alt="Logo SVE">
        <span class="textoLogo">Sociedad Venezolana<br>de Espeleología</span>
      </div>
      <div class="Blk-sesion" v-if="!sesion">
        <router-link to="/bienvenida" class="Sesion">
          <img class="icoBib" src="../assets/icoBibSVE.png">
        </router-link>
        <div class="usuario">
          <!-- <div class="icoUser">
            <img class="fotoUser" :src="usuarioEnSesion.foto" alt="foto usuario">
          </div> -->
          {{usuarioEnSesion.nombre}}
        </div>
        <div class="salir">
          <img class="icoSalir" src="../assets/icoSalir.png" @click="closeSession">
        </div>
      </div>
      <div class="dropdown" v-if="sesion">
        <img class="tresPuntos" src="../assets/TresPuntos.png" @click="abreMenu">
        <transition name="trans">
          <div v-show="dropShow" class="dropdown-content">
            <router-link to="/login">Login</router-link>
            <router-link to="/registro">Registro</router-link>
            <!-- <div>Redes sociales de la SVE</div> -->
          </div>
        </transition>
      </div>
    </div>
    <div class="Row2">
      <p>{{titulo}}</p>
    </div>
    <div class="Row3" @click="closeMenu">
      <p class="texto1">{{texto1}}</p>
      <p class="texto2">{{texto2}}</p>
      <p class="texto3">{{texto3}}</p>
    </div>
    <div class="Row4">
      <div class= "bloque-idioma">
          <i :class="{seleccionado: idiomaSel=='ES'}" @click="eligeIdioma('ES')">ES</i> |
          <i :class="{seleccionado: idiomaSel=='EN'}" @click="eligeIdioma('EN')">EN</i> |
          <i :class="{seleccionado: idiomaSel=='FR'}" @click="eligeIdioma('FR')">FR</i> |
          <i :class="{seleccionado: idiomaSel=='IT'}" @click="eligeIdioma('IT')">IT</i>
      </div>
      <p>{{textoBaja}}</p>

      <img class="SymSima" src="../assets/SymSimaOran.png" alt="" @click="abrePagCol">
        <!-- <transition :name ='transicionSel'>
          <RouterView></RouterView>
        </transition> -->
        <!-- <router-view v-slot="{ Component }">
          <transition>
            <component :is="Component" />
          </transition>
        </router-view> -->
      <!-- <button @click="alertJoa('Prueba', 'W')">Alert</button> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
export default {
  name: 'Home',
  created () {
    document.onclick = this.documentClick
  },
  mounted () {
    this.eligeIdioma('ES')
  },
  data () {
    return {
      idiomaSel: '',
      transicionSel: '',
      titulo: '',
      texto1: '',
      texto2: '',
      texto3: '',
      textoBaja: '',
      textos: {
        ES: {
          titulo: 'Catálogo de la biblioteca',
          texto1: 'La Sociedad Venezolana de Espeleología fue fundada en el año 1967 y desde entonces ha realizado exploraciones y estudios del ámbito cavernario.',
          texto2: 'Fruto de estas investigaciones y de los intercambios con otras entidades en todo el mundo ha recopilado una considerable cantidad de material bibliográfico.',
          texto3: 'En este catálogo se recoge el contenido de su biblioteca.',
          textoBaja: 'Desciende la sima para ver las colecciones.'
        },
        EN: {
          titulo: 'SVE Library catalog',
          texto1: 'Since its foundation in 1967, the Venezuelan Speleology Society (SVE) has compiled a considerable amount of bibliographic material.',
          texto2: 'Part as a result of their own research and part as an exchange of information with other institutions.',
          texto3: 'In this catalog you can find the content of SVE library.',
          textoBaja: 'Go down the chasm to see the collections'
        },
        FR: {
          titulo: 'Catalogue de la bibliothèque',
          texto1: 'La Société Vénézuélienne de Spéléologie a été fondée en 1967 et depuis lors, elle a effectué des explorations et des études de l\'environnement des grottes.',
          texto2: 'À la suite de ces recherches et de l\'échange d\'information avec d\'autres entités dans le monde, il a compilé une quantité considérable de matériel bibliographique.',
          texto3: 'Ce catalogue compile le contenu de sa bibliothèque.',
          textoBaja: 'Descendez le gouffre pour voir les collections'
        },
        IT: {
          titulo: 'Catalogo della biblioteca',
          texto1: 'Dalla sua fondazione nel 1967, la Società venezuelana di speleologia ha compilato una notevole quantità di materiale bibliografico.',
          texto2: 'Parte come risultato della propria ricerca e parte come scambio di informazioni con altre istituzioni.',
          texto3: 'In questo catalogo puoi trovare i contenuti della biblioteca.',
          textoBaja: 'Scendi nella voragine per vedere le collezioni.'
        }
      },
      dropShow: false
    }
  },
  methods: {
    abrePagCol () {
      this.$router.push('/page2')
    },
    abreMenu () {
      this.dropShow = true
    },
    documentClick (e) {
      if (!e.target.matches('.tresPuntos')) {
        this.dropShow = false
      }
    },
    eligeIdioma (ID) {
      this.idiomaSel = ID
      this.titulo = this.textos[ID].titulo
      this.texto1 = this.textos[ID].texto1
      this.texto2 = this.textos[ID].texto2
      this.texto3 = this.textos[ID].texto3
      this.textoBaja = this.textos[ID].textoBaja
    },
    closeSession () {
      this.$store.commit('doLogout')
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState(['usuarioEnSesion']),
    sesion () {
      return (this.usuarioEnSesion.nombre === undefined)
    }
  },
  watch: {
    '$route' (to, from) {
      this.transicionSel = to.path === '/page2' ? 'toggle' : 'fade'
    }
  }
}
</script>

<style scoped>
/* .home{
  background-color: rgb(199, 199, 199);
  /* height: 100%;
  width: 100%;
} */
* {
  margin: 0;
  padding: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.contenedor{
  height: 100vh;
  width: 100vw;
  display: grid;
  /*grid-template-rows: calc(15% * 0.9 vw) calc(10% * 0.5vw) 50% 25%;*/
  grid-template-rows: 15% 10% 50% 25%;
  color:white;
}
.Row1{
  display:flex;
  justify-content: space-between;
  min-height: 70px;
  /* border: solid 1px orange; */
}
.Blk-SVE{
  /* border: solid 1px orange; */
  width: 35%;
  min-width: 220px;
  /* margin-top: 2vh; */
  color:  rgb(250, 251, 251);
  display: grid;
  grid-template-columns: 30% 70%;
  align-items: center;
}
.logo{
  width: 48%;
  min-width: 35px;
  /* border: solid 1px orange; */
  justify-self:right;
  align-self:center;
  margin-right: 0.4rem;
}
.textoLogo{
  /* border: solid 1px orange; */
  width: 90%;
  text-align:left ;
  font-family:ErasMD;
  padding-top: 0.15rem;
  font-size: calc(0.80vw + 11px);
  padding-left: 4px;
  /* font-size: 100%; */
}

.Blk-sesion{
 display:flex;
 align-items: center;
 width: 18vw;
 justify-content: space-around;
 /* height: 50%; */
 /* border: solid 0.5px orange; */
 margin-right: 2%;
}
.icoBib{
  height: 24px;
}
.usuario{
  /* border: solid 1px orange; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.icoUser{
  display: inline-block;
  position: relative;
  width: 35px;
  height: 35px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 15px;
}
.fotoUser{
  width: 100%;
  height: auto;
  margin-top: -12%;
  /* margin-top: 10px;*/
}
/* .salir{
  border: solid 0px orange
} */
.icoSalir{
  height: 24px;
  cursor: pointer;
}

.Sesion {
  /* position:relative; */
  color: white;
  /* padding:10px;
  right: 36px;
  top: 16px; */
  cursor: pointer;
  /* border: solid 1px orange */
}
.tresPuntos {
    /* background-color: #4CAF50; */
    position:absolute;
    color: white;
    padding:10px;
    right: 16px;
    top: 26px;
    /* padding: 26px 26px; */
    height: 20px;
    border: none;
    cursor: pointer;
    /* border: solid 1px orange */
}
.dropdown {
  position: relative;
  padding-top: 60px;
  /* display: inline-block; */
  float: right;
  /* border: solid 1px orange; */
}
.trans-enter-active, .trans-leave-active {
  transition: opacity .3s ease-in;
}
.trans-enter-from, .fade-leave-to {
  opacity: 0;
}

.dropdown-content {
    display: block;
    position:absolute;
    background-color: rgba(1, 117, 163, 0.95);
    min-width: 120px;
    z-index: 1;
    right: 0;
    color: var(--na);
    /* opacity:0; */
    /* transition: 1s ease-out; */
}
.dropdown-content a {
    /* color: rgb(255, 169, 30); */
    padding: 8px 26px;
    text-decoration: none;
    display: block;
    text-align: right;
    color: var(--na);
    font-size: 1.1em;
}
.dropdown-content a:hover {
  background-color: rgba(1, 98, 136, 0.7);
  }
.Row2{
  justify-self: center;
  padding-left: 7%;
  /* border: solid 1px orange */
}
.Row2 p {
  font-size: calc(2vw + 20px);
  font-weight: lighter;
  color:rgb(44, 158, 187);
}
.Row3{
  width: 75%;
  max-width: 450px;
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 7%;
  /* border: solid 1px orange; */
}
.Row3 p {
  color:white;
  /* font-size: 3vh; */
  font-size: calc(1.9vh + 7px);
  margin-bottom: 10px;
  padding-top: 5px;
}
.Row4{
  padding-left: 7%;
}
.Row4 p {
  color:rgb(92, 92, 92);
  margin-top: 15px;
  /* padding-left: 7%; */
  /* font-family: SegoeL; */
}
.texto3{
  width:300px;

}
.SymSima{
  height: 30px;
  margin-top: 15px;
  -moz-transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.SymSima:hover{
  transform: translateY(5px);
  /* cursor: pointer; */
}
i{
  color: rgb(92, 92, 92);
  font-weight:400;
}
.seleccionado {
  font-weight:450;
  color:rgb(252, 253, 253);
  /*color: rgb(255, 169, 30);*/
}

/* .bloque-idioma i{
  align-items: center;
} */

.bloque-idioma i:hover{
  cursor: pointer;
  /* gitcolor: rgb(255, 169, 30); */
}
@media screen and (max-width: 575px){
  .contenedor{
    background-image: url("../assets/fondos/Fondo_tel_BP.jpg");
    background-size: cover;

    display: flex;
    flex-direction: column;
    align-content:flex-end;
  }
  .icoBib{
    height: 20px;
  }
  .Row1{
    height: 15vh;
    /* border: solid 0.5px orange; */
  }
  .Blk-sesion{
    display:flex;
    align-items: center;
    width: 40vw;
    justify-content: space-around;
    /* height: 50%; */
    /* border: solid 0.5px orange; */
    margin-right: 0%;
  }
  .Row2{
    height: 6vh;
    padding-left: 0;
    /* border: solid 0.5px orange; */
  }
  .Row3{
    height: 58vh;
    width: 100%;
    text-align:center;
    padding-left: 0;
    /* border: solid 0.5px orange; */
  }
  .Row3 p{
    font-size: 4.9vw;
    font-weight: 100;
    text-shadow: -3px -1px 5px black;
    margin-bottom: 5px;
  }
  .texto1{
    padding-left: 20px;
    padding-right:20px;
  }
  .texto2{
    padding-left: 20px;
    padding-right:20px;
  }
  .texto3{
    /* width: 100%; */
    padding-left: 20px;
    padding-right: 20px;
  }
  .Row4{
    padding-left: 0;
  }
  .bloque-idioma i{
    margin-right: 4px;
    margin-left: 4px;
  }
}
@media screen and (max-width: 370px){
  .logo{
    width: 47%;
    min-width: 30px;
  }
  .textoLogo{
    width: 90%;
    text-align:left ;
    font-family:ErasMD;
    padding-top: 0.1rem;
    font-size: calc(0.80vw + 9px);
    padding-left: 4px;
    /* font-size: 100%; */
  }
  .usuario{
    font-size: 13px;
  }
  .icoSalir{
    height: 22px;
  }
  .contenedor{
    background-position: center -30px;
  }
  .Row4{
    padding-top: 7%;
  }
  .bloque-idioma{
    color: white;
  }

}
</style>
